module.exports = __webpack_public_path__ + "img/u1280.a04efc53.svg";